import moment from "moment";
import "moment/locale/es";
import {cuentaMask, dineroDisabledMask} from '../Components/Items'
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const reportesDeVentasPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []
    if(values.clientes !== 0 && values.clientes && values.clientes.length > 0){
        let textoFiltrado = ''
        values.clientes.map((valueCliente) => {
            textoFiltrado += `${(valueCliente.persona ? valueCliente.nombre : (valueCliente.nombre+' '+valueCliente.apellidoPaterno+' '+valueCliente.apellidoMaterno)) + valueCliente.razonSocial + " - " + valueCliente.rfc}\n`
            return null
        })
        filtrados.push([
            {text: 'Clientes:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.vendedores !== 0 && values.vendedores && values.vendedores.length > 0){
        let textoFiltrado = ''
        values.vendedores.map((valueVendedores) => {
            textoFiltrado += `${valueVendedores.nombre +
                " " +
                valueVendedores.apellidoPaterno +
                " " +
                valueVendedores.apellidoMaterno}\n`
            return null
        })
        filtrados.push([
            {text: 'Vendedores:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    const tablasDinamicas = [];

    const escuelaActivo = !!empresa?.escuela;
    const ventaOnlineActivo = !!empresa?.ventaOnline;
    const mostrarObligatorio = escuelaActivo && !!values.desglosarProductos;

    // Columnas base + columnas opcionales (Envío / Escuela / Obligatorio), con
    // anchos normalizados a 100% según cuáles estén activas.
    const columnasTabla = [
        { title: 'Folio', width: 6, align: 'left', totalKey: null },
        { title: 'Fecha', width: 7, align: 'center', totalKey: null },
        { title: 'Cliente', width: 15, align: 'left', totalKey: null },
        { title: 'Vencimiento', width: 7, align: 'center', totalKey: null },
        { title: 'Total A Cobrar', width: 8, align: 'right', totalKey: 'totalACobrar' },
        { title: 'Costo', width: 7, align: 'right', totalKey: 'totalCosto' },
        { title: 'Abonos', width: 7, align: 'right', totalKey: 'totalPagado' },
        { title: 'Saldo', width: 7, align: 'right', totalKey: 'totalSaldo' },
        { title: 'Estado', width: 6, align: 'left', totalKey: null },
        { title: 'Vendedor', width: 8, align: 'left', totalKey: null },
    ];
    if (ventaOnlineActivo) {
        columnasTabla.push({ title: 'Tipo de Envío', width: 8, align: 'left', totalKey: null, campo: 'tipoEnvio' });
    }
    if (escuelaActivo) {
        columnasTabla.push({ title: 'Escuela', width: 8, align: 'left', totalKey: null, campo: 'escuela' });
    }
    if (mostrarObligatorio) {
        columnasTabla.push({ title: 'Obligatorio', width: 6, align: 'center', totalKey: null, campo: 'obligatorio' });
    }
    if (values.formaPagoReal) {
        columnasTabla.push({ title: 'Forma de Pago', width: 8, align: 'left', totalKey: null, campo: 'formaPago' });
    }
    const anchoTotal = columnasTabla.reduce((suma, col) => suma + col.width, 0);
    const anchosTabla = columnasTabla.map((col) => `${(col.width / anchoTotal * 100).toFixed(2)}%`);

    const porMoneda = {};
    values.ventas.forEach((venta) => {
        const monedaKey = venta.moneda || "Sin Moneda";
        if (!porMoneda[monedaKey]) porMoneda[monedaKey] = [];
        porMoneda[monedaKey].push(venta);
    });

    Object.keys(porMoneda).forEach((moneda) => {
        const ventasMoneda = porMoneda[moneda];

        const totales = {
            totalACobrar: 0,
            totalCosto: 0,
            totalPagado: 0,
            totalSaldo: 0,
            totalSubtotal: 0,
            totalImpuestos: 0,
            totalRetenciones: 0,
        };

        const filasVentas = ventasMoneda.map((valueVenta) => {
            const properties = valueVenta.colorStyle ? { background: valueVenta.colorStyle } : {};

            totales.totalACobrar += parseFloat(valueVenta.totalPagar || 0);
            totales.totalCosto += parseFloat(valueVenta.costoTotal || 0);
            totales.totalPagado += parseFloat(valueVenta.totalPagado || 0);
            totales.totalSaldo += parseFloat(valueVenta.saldo || 0);
            totales.totalSubtotal += parseFloat(valueVenta.subtotal || 0);
            totales.totalImpuestos += parseFloat(valueVenta.totalImpuestos || 0);
            totales.totalRetenciones += parseFloat(valueVenta.totalRetenciones || 0);

            return columnasTabla.map((col) => {
                switch (col.title) {
                    case 'Folio':
                        return { text: valueVenta.folio, style: 'textoTabla', alignment: col.align };
                    case 'Fecha':
                        return { text: isNaN(valueVenta.fechaFactura) ? moment(valueVenta.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueVenta.fechaFactura, style: 'textoTabla', alignment: col.align };
                    case 'Cliente':
                        return { text: valueVenta.cliente, style: 'textoTabla', alignment: col.align };
                    case 'Vencimiento':
                        return { text: isNaN(valueVenta.fechaVencimiento) ? (moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L') !== 'Fecha inválida' ? moment(valueVenta.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L') : 'No tiene') : valueVenta.fechaVencimiento, style: 'textoTabla', alignment: col.align };
                    case 'Total A Cobrar':
                        return { text: dineroDisabledMask(valueVenta.totalPagar), style: 'textoTabla', alignment: col.align };
                    case 'Costo':
                        return { text: dineroDisabledMask(valueVenta.costoTotal), style: 'textoTabla', alignment: col.align };
                    case 'Abonos':
                        return { text: dineroDisabledMask(valueVenta.totalPagado), style: 'textoTabla', alignment: col.align };
                    case 'Saldo':
                        return { text: dineroDisabledMask(valueVenta.saldo), style: 'textoTabla', alignment: col.align };
                    case 'Estado':
                        return { text: valueVenta.estado, ...properties, style: 'textoTabla', alignment: col.align };
                    case 'Vendedor':
                        return { text: valueVenta.vendedor, style: 'textoTabla', alignment: col.align };
                    case 'Obligatorio':
                        return { text: valueVenta.obligatorio === 'Obligatorio' ? 'X' : '', style: 'textoTabla', alignment: col.align };
                    default:
                        return { text: valueVenta[col.campo] || '', style: 'textoTabla', alignment: col.align };
                }
            });
        });

        // Fila de totales para esta moneda
        filasVentas.push(columnasTabla.map((col, index) => {
            if (index === 0) {
                return { text: `TOTAL (${moneda}):`, style: 'totalChico', alignment: 'left', border: [true, true, true, true], fillColor: '#cccccc' };
            }
            if (col.totalKey) {
                return { text: dineroDisabledMask(totales[col.totalKey]), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' };
            }
            const esUltima = index === columnasTabla.length - 1;
            return { text: '', style: 'totalChico', border: [false, true, esUltima, true], fillColor: '#cccccc' };
        }));

        tablasDinamicas.push(
            { text: `Moneda: ${moneda}`, style: "subheader", margin: [0, 5, 0, 2] },
            {
                style: 'tableExample',
                table: {
                    widths: anchosTabla,
                    headerRows: 1,
                    body: [
                        columnasTabla.map((col) => ({ text: col.title, style: 'tituloTabla' })),
                        ...filasVentas
                    ]
                },
                layout: {
                    fillColor: (rowIndex) => rowIndex % 2 === 0 && rowIndex !== 0 ? "#e8e8e8" : "#ffffff",
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 1 : 1,
                    vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length) ? 1 : 1,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                    hLineStyle: (i, node) => (i === 0 || i === node.table.body.length) ? null : { dash: { length: 2, space: 1 } },
                    vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length) ? null : { dash: { length: 2 } },
                }
            },
            // Resumen financiero por moneda
            {
                margin: [0, 2, 0, 8],
                table: {
                    widths: ['19%', '3%', '19%', '3%', '19%', '3%', '19%', '3%', '12%'],
                    body: [
                        [
                            { text: 'Subtotal', style: 'tituloTabla', alignment: 'center' },
                            { text: '+', style: 'textoTabla', alignment: 'center', border: [false, false, false, false] },
                            { text: 'Impuestos', style: 'tituloTabla', alignment: 'center' },
                            { text: '=', style: 'textoTabla', alignment: 'center', border: [false, false, false, false] },
                            { text: 'Total', style: 'tituloTabla', alignment: 'center' },
                            { text: '-', style: 'textoTabla', alignment: 'center', border: [false, false, false, false] },
                            { text: 'Retenciones', style: 'tituloTabla', alignment: 'center' },
                            { text: '=', style: 'textoTabla', alignment: 'center', border: [false, false, false, false] },
                            { text: 'Total A Cobrar', style: 'tituloTabla', alignment: 'center' },
                        ],
                        [
                            { text: dineroDisabledMask(totales.totalSubtotal), style: 'totalChico', alignment: 'right', fillColor: '#e8e8e8' },
                            { text: '', border: [false, false, false, false] },
                            { text: dineroDisabledMask(totales.totalImpuestos), style: 'totalChico', alignment: 'right', fillColor: '#e8e8e8' },
                            { text: '', border: [false, false, false, false] },
                            { text: dineroDisabledMask(totales.totalSubtotal + totales.totalImpuestos), style: 'totalChico', alignment: 'right', fillColor: '#e8e8e8' },
                            { text: '', border: [false, false, false, false] },
                            { text: dineroDisabledMask(totales.totalRetenciones), style: 'totalChico', alignment: 'right', fillColor: '#e8e8e8' },
                            { text: '', border: [false, false, false, false] },
                            { text: dineroDisabledMask(totales.totalACobrar), style: 'totalChico', alignment: 'right', fillColor: '#cccccc' },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length) ? 1 : 0,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                }
            }
        );
    });

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},
            {text: '', style: 'textoChico'}
      ] )
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
          content: [
              {
                  style: 'tableExample',
                  table: {
                      widths: [ '18%', '52%', '30%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: [
                          [
                              ...HeaderEmpresaCard(empresa, false,false,
                              {
                                  border: [false, false, false, false],
                                      table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                          [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              }),
                          ]
      
                      ]
                  },
              },
              {
                text:
                "Reporte de Ventas",
                style: "tableHeaderIzquierda",
              },
              {text: 'Datos de filtrado:'},
              {
                  style: 'tableExample',
                  table: {
                      widths: ['20%', '80%'],
                      layout: {
                                          defaultBorder: false,
                                      },
                      
                      body: filtrados,
                  },
                              layout: {
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
                  
              },
              ...tablasDinamicas,
          ],
          images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
          },
          styles: {
              tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
              header: {
                  fontSize: 9,
                  bold: true,
              },
              subheader: {
                  fontSize: 8,
                  bold: true,
              },
              tableExample: {
                  margin: [0, 5, 0, 5]
              },
              tablaSinMargen: {
                  margin: [0, 0, 0, 0]
              },
              tableHeader: {
                  bold: true,
                  fontSize: 12,
                  color: 'black',
                  alignment: 'center'
              },
              textoChico:{
                  fontSize: 8
              },
              tituloTabla:{
                  fontSize: 8,
                  bold: true, 
                  fillColor: '#cccccc', 
                  style: 'subheader', 
                  alignment: 'center',
                  border: true
              },
              textoTabla: {
                  fontSize: 8,
                  italics: false
              },
              totalChico: {
                fontSize: 6,
                bold: true,
                fillColor: '#cccccc',
                alignment: 'right',
                border: true
            }
            
          },
          pageSize: 'LETTER',
          pageOrientation: 'landscape',
          pageMargins: [ 20, 20, 20, 60 ],
    }
  return dd;
};


export default reportesDeVentasPdf;
